import "./Tiers.css";
import Spike from "@/components/Icons/Spike";
import Medici from "@/components/Icons/Medici";

/* ------------------------------------------------------------------------------------ */

export default function Tiers() {
	return (
		<section className="sponsor-section-tiers">
			{/* SPIKE */}
			<div className="tier-card">
				<div>
					<header className="tier-card-header">
						<h3>Spike</h3>
						<Spike />
					</header>

					<div className="tier-card-text">
						<p className="tier-card-text-highlight">
							Fancy giving our core team (Max, Niccolò, and Dave) a boost?
						</p>
						<p>
							Your sponsorship will empower us to dive deeper into research,
							build new practical tools, create valuable resources and share
							them with the brain emulation and broader community.
						</p>
						<p>
							P.S. You can also show your support, and learn a thing or two, by
							grabbing Level 2 of the{" "}
							<a href="TODO" target="_blank" rel="noopener noreferrer">
								BrainEm Quiz
							</a>
							.
						</p>
					</div>
				</div>

				<button type="button">Sponsor</button>
			</div>

			{/* ------------------------------------------------------------------------------ */}

			{/* MEDICI */}
			<div className="tier-card">
				<div>
					<header className="tier-card-header">
						<h3>Medici</h3>
						<Medici />
					</header>

					<div className="tier-card-text">
						<p className="tier-card-text-highlight">
							Envisioning a larger impact with a contribution of $10,000 or
							more?
						</p>
						<p>
							Let’s discuss how to translate your neuro-patronage into
							successful, tangible outcomes.
						</p>
						<p>
							We actively seek out high-leverage opportunities, whether that
							means our team tackling a focused problem, or orchestrating a
							collaborative effort with vetted, motivated partners committed to
							advancing brain emulation.
						</p>
					</div>
				</div>

				<a href="mailto:team@brainem.co" className="tier-card-btn">
					Send us a note
				</a>
			</div>
		</section>
	);
}
